import axios from 'axios';
import messages from '../../statics/messages.json';

/** Calls to the User Administration API (service/controls/userAdminService.js). */

const baseUrl = () => {
    const isLocal = window.location.hostname === 'localhost';
    const port = isLocal ? messages.node_server_port : '';
    return `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}/api/admin`;
};

const call = async (method, path, data) => {
    try {
        const response = await axios({ method, url: `${baseUrl()}${path}`, data, withCredentials: true });
        return response.data;
    } catch (err) {
        const status = err?.response?.status;
        const body = err?.response?.data || {};
        const error = new Error(body.message
            || (status ? `The server turned this down (${status}). Try again.` : 'Bridge couldn’t reach the server. Check your connection and try again.'));
        error.status = status;
        error.blocked = !!body.blocked;
        throw error;
    }
};

const id = (value) => encodeURIComponent(value);

export const getMe = () => call('get', '/me');
export const getCatalog = () => call('get', '/catalog');
export const getState = () => call('get', '/state');

export const addPerson = (person) => call('post', '/people', person);
/** The edit panel's Save: `{ profile, access }`, either part optional. */
export const savePerson = (personId, changes) => call('put', `/people/${id(personId)}`, changes);
export const setAccess = (personId, access) => call('put', `/people/${id(personId)}/access`, access);
export const bulkRole = (ids, role) => call('post', '/people/role', { ids, role });
export const deactivate = (ids, details) => call('post', '/people/deactivate', { ids, ...details });
export const cancelDeactivation = (personId) => call('post', `/people/${id(personId)}/cancel-deactivation`);
export const reactivate = (personId, role) => call('post', `/people/${id(personId)}/reactivate`, { role });
export const markInvited = (personId) => call('post', `/people/${id(personId)}/invite`);
/** Sets up people who already sign in to Bridge. Each person is `{ email, first, last, title }`. */
export const importPeople = (people, dept, role) => call('post', '/people/import', { people, dept, role });

export const createRole = (fromRoleId, name) => call('post', '/roles', { fromRoleId, name });
export const updateRole = (roleId, changes) => call('put', `/roles/${id(roleId)}`, changes);

export const undo = (token) => call('post', `/undo/${id(token)}`);
